import { Component, inject } from "@angular/core";
import { MessageSeverity } from "@dcc/shared/domain";
import { VdsInlineAlert } from "@dcc/vestas-design-system/angular/components/inline-alert";
import { PlatformAlertsStore } from "@dcc/vestas-online/platform-alerts/data-access";

@Component({
    selector: "vo-um-user-alert",
    templateUrl: "./user-alert.component.html",
    imports: [VdsInlineAlert],
    host: {
        class: "print:hidden"
    }
})
export class UserAlertComponent {
    protected readonly store = inject(PlatformAlertsStore);
    protected readonly severity = MessageSeverity;
}
